import React from 'react';
import { brand, avarisWordmark } from '../constants/assets';
import { cn } from '../lib/cn';

interface LogoProps {
  className?: string;
}

export default function Logo({ className }: LogoProps) {
  return (
    <div className={cn('flex shrink-0 items-center gap-2', className)}>
      <img
        src={brand}
        alt=""
        className="block h-8 w-auto shrink-0"
        loading="eager"
      />
      <img
        src={avarisWordmark}
        alt="Avaris"
        loading="lazy" 
        className="block h-[15px] w-auto shrink-0"
      />
    </div>
  );
}
